module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader"
  }, [_c('svg', {
    staticStyle: {
      "white-space": "pre"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "shape-rendering": "geometricPrecision",
      "text-rendering": "geometricPrecision",
      "viewBox": "0 0 130 130"
    }
  }, [_c('defs', [_c('symbol', {
    attrs: {
      "id": "sota_dot",
      "preserveAspectRatio": "none",
      "width": "100",
      "height": "100",
      "viewBox": "0 0 100 100",
      "overflow": "visible"
    }
  }, [_c('rect', {
    staticStyle: {
      "animation": "a0_t 2.5s linear infinite both"
    },
    attrs: {
      "width": "100",
      "height": "100",
      "fill": _vm.color,
      "stroke": "none",
      "transform": "translate(100.5,0.5) scale(0.01,0.01) translate(-50,-50)"
    }
  })])]), _vm._v(" "), _c('use', {
    staticStyle: {
      "animation": "a1_t 2.5s linear infinite both"
    },
    attrs: {
      "width": "100",
      "height": "100",
      "xlink:href": "#sota_dot",
      "transform": "translate(80,50) translate(-50,-50)"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7af321ef","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Loader.vue
// module id = 47
// module chunks = 7